import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'alienala-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alienala-loader.component.html',
  styleUrl: './alienala-loader.component.scss'
})
export class AlienalaLoaderComponent {
  @Input() message: string = 'Chargement en cours...';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() fullscreen: boolean = false;
}
